import { AppThunk } from '../../../store/rootReducer';
import * as layoutActions from '../../layout/actions/layout.actions';
import * as beatsActions from '../../beats/beats.actions';
import { sortingStrategySelector } from '../../layout/selectors/layout.selectors';
import { pinnedIdSelector } from '../../beats/beats.selector';

export const togglePinnedBeat =
  (beatId?: number): AppThunk =>
  async (dispatch, getState) => {
    const sortingStrategy = sortingStrategySelector(getState());
    const pinnedId = pinnedIdSelector(getState());
    if (
      (beatId === pinnedId || beatId == null) &&
      sortingStrategy === 'Distance to pinned beat'
    ) {
      dispatch(layoutActions.update({ update: { sortingStrategy: 'Time' } }));
    }
    dispatch(
      beatsActions.togglePinnedBeat({
        id: beatId === pinnedId ? undefined : beatId,
      }),
    );
  };
